import { render, staticRenderFns } from "./VideoIndex.vue?vue&type=template&id=75ecbfb1"
import script from "./VideoIndex.vue?vue&type=script&lang=js"
export * from "./VideoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports